import Vue from 'vue'

import App from './App'

import { sync } from 'vuex-router-sync'
import NP from 'number-precision'

import router, { redirectList } from './router'
import './i18n'
import store from './store'
import { getStorage } from './utils/stroage/stroage'
import { __TOKEN__ } from './utils/stroage/nameSpace'
import * as filters from './filters' 
import handleClipboard from './utils/clipboard'
import config from './config'
import ColorDirective from './directives/color'

import Confirm from './components/Confirm'

import './utils/rem'
import './utils/toast'

import './statics/font/iconfont.css'
import './theme/index.less'

import DatetimePlugin from 'vux/src/plugins/datetime/index.js'
import CloseDialogsPlugin from 'vux/src/plugins/close-dialogs/index.js'
import ConfigPlugin from 'vux/src/plugins/config/index.js'
import DevicePlugin from 'vux/src/plugins/device/index.js'
import AppPlugin from 'vux/src/plugins/app/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


import './system'

Vue.config.productionTip = false

require('es6-promise').polyfill()

Vue.prototype.$NP = NP

NP.enableBoundaryChecking(false)


Vue.use(ConfigPlugin, {
$layout: 'VIEW_BOX' 
})
Vue.use(Confirm)


Object.keys(filters).forEach(key => {
Vue.filter(key, filters[key])
})


Vue.use(DevicePlugin)
Vue.use(DatetimePlugin)
Vue.use(ConfirmPlugin)

Vue.directive('TransferDom', TransferDom)
Vue.directive('Color', ColorDirective)


if (process.env.platform === 'app') {
Vue.use(AppPlugin, store)
}




Vue.use(CloseDialogsPlugin, router)

sync(store, router)

router.beforeEach(function (to, from, next) {
if (/\/http/.test(to.path)) {
let url = to.path.split('http')[1]
window.location.href = `http${url}`
} else {
if (redirectList.find(item => to.path === item)) {
next()
} else {
if (getStorage(__TOKEN__) && store.state.user.token) {
return next()
} else {

return next('/login')
}
}

}
})

Vue.prototype.$loading = {
visible: store.state.vux.loading.visible,
show (txt) {
store.commit('updateLoadingStatus', { isLoading: true, loadingTxt: txt })
},
hide (txt) {
if (txt) {
setTimeout(() => {
store.commit('updateLoadingStatus', { isLoading: false, loadingTxt: txt })
}, 2000)
} else {
store.commit('updateLoadingStatus', { isLoading: false })
}
}
}

Vue.prototype.$copy = function (val, evt) {
if (!val) return
handleClipboard(val, evt)
}

Vue.prototype.$config = config

document.title = process.env.VUE_APP_NAME

export default new Vue({
store,
router,
render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js